import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    videos: [],
    deletedVideos: [],
  },
  mutations: {
    setVideos(state, payload) {
      state.videos = payload
    },
    sortVideos(state) {
      state.videos.sort((a, b) => (a.data.publishDue < b.data.publishDue) ? 1 : -1)
    },
    insertVideo(state, payload) {
      const videoData = {
        description: payload.payload.description,
        tags: [
          payload.payload.tags,
        ],
        title: payload.payload.dashboard ? 'title goes here...' : 'CONCEPT: ' + payload.payload.description,
        titleDue: moment(payload.payload.publishDate).subtract(9, 'days').format('YYYY-MM-DD'),
        thumbnailDue: moment(payload.payload.publishDate).subtract(8, 'days').format('YYYY-MM-DD'),
        scriptDue: moment(payload.payload.publishDate).subtract(7, 'days').format('YYYY-MM-DD'),
        filmDue: moment(payload.payload.publishDate).subtract(6, 'days').format('YYYY-MM-DD'),
        editDue: moment(payload.payload.publishDate).subtract(5, 'days').format('YYYY-MM-DD'),
        tagsDue: moment(payload.payload.publishDate).subtract(4, 'days').format('YYYY-MM-DD'),
        descriptionDue: moment(payload.payload.publishDate).subtract(3, 'days').format('YYYY-MM-DD'),
        uploadDue: moment(payload.payload.publishDate).subtract(2, 'days').format('YYYY-MM-DD'),
        promoteDue: moment(payload.payload.publishDate).subtract(1, 'days').format('YYYY-MM-DD'),
        publishDue: moment(payload.payload.publishDate).format('YYYY-MM-DD'),
        engageDue: moment(payload.payload.publishDate).add(1, 'days').format('YYYY-MM-DD'),
      }
      const video = {
        videoID: uuidv4(),
        data: videoData,
        daysFromPublish: Math.round(moment.duration(moment().diff(videoData.publishDue)).asDays()),
        change: 'create',
      }
      state.videos.push(video)
      this.commit('creator/videos/sortVideos')
    },
    removeVideo(state, payload) {
      const index = state.videos.indexOf(payload.video)
      if (index > -1) {
        state.videos.splice(index, 1)
      }
      state.deletedVideos.push(payload.video)
      this.commit('creator/videos/sortVideos')
    },
  },
  actions: {
    // read videos when app loads
    async getVideos(context) {
      const videosPayload = []
      await firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('videos')
        .orderBy('publishDue', 'desc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              videoID: doc.id,
              data: doc.data(),
              daysFromPublish: Math.round(moment.duration(moment().diff(doc.data().publishDue)).asDays()),
            }
            videosPayload.push(data)
          })
        })
      context.commit('setVideos', videosPayload)
    },
    // update an existing video
    async updateVideo(context, video) {
      console.log(context)
      const videoData = video.video.data
      const videoID = video.video.videoID
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('videos')
        .doc(videoID)
        .set(videoData)
    },
    // delete a video
    async deleteVideo(context, video) {
      console.log(context)
      const videoID = video.video.videoID
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('videos')
        .doc(videoID)
        .delete()
        // .then(res => {
        //   console.log(res)
        //   context.commit('removeVideo', video)
        // })
    },
  },
  getters: {
    state: state => state,
  },
}
